import type { RotasDoModulo } from '@/app/rotas';

import { PolicyholderDetailPage } from './detail/PolicyholderDetailPage';
import { PolicyholdersPage } from './PolicyholdersPage';

/** A lista de tomadores e o detalhe do tomador. */
export const rotas: RotasDoModulo = {
  menu: { '/tomadores': PolicyholdersPage },
  moldura: [
    {
      path: '/tomadores/:policyholderId',
      element: <PolicyholderDetailPage />,
    },
  ],
};
